import { combineReducers } from "@reduxjs/toolkit";
import { layersReducer } from "./layersReducer.js";
import { initReducer } from "./initReducer.js";
import { sourcesReducer } from "./sourcesReducer.js";
import { assistantReducer } from "./chatReducer.js";
import { apiKeyReducer } from "./apiKeyReducer.js";
import { settingsReducer } from "./settingReducer.js";
import { markersReducer } from "./markerReducer.js";
export const rootReducer = combineReducers({
    chat: assistantReducer,
    layers: layersReducer,
    sources: sourcesReducer,
    init: initReducer,
    apiKey: apiKeyReducer,
    settings: settingsReducer,
    markers: markersReducer,
});
